import { SiTiktok } from 'react-icons/si';
import { CheckCircle } from 'lucide-react';
import { PreviewCardShell } from './PreviewCardShell';

interface TikTokProfileMockupProps {
  username?: string;
  bio: string;
  followers?: string;
  following?: string;
  likes?: string;
  verified?: boolean;
  previewLabel?: string;
}

export const TikTokProfileMockup = ({
  username = '@username',
  bio,
  followers = '0',
  following = '0',
  likes = '0',
  verified = false,
  previewLabel = 'TikTok Profile Preview',
}: TikTokProfileMockupProps) => {
  return (
    <PreviewCardShell
      className="mb-3"
      bodyClassName="p-4"
      badgeClassName="bg-gradient-to-r from-[#00f2ea] to-[#ff0050]"
      badge={<SiTiktok className="h-4 w-4 text-white" />}
      label={previewLabel}
    >
        {/* Profile picture */}
        <div className="flex flex-col items-center mb-4">
          <div className="w-24 h-24 rounded-full bg-gradient-to-br from-[#00f2ea] to-[#ff0050] mb-3" />

          {/* Username */}
          <div className="flex items-center gap-1.5 mb-2">
            <h3 className="text-lg font-semibold text-zinc-50">{username}</h3>
            {verified && <CheckCircle className="w-5 h-5 text-[#20D5EC]" fill="currentColor" />}
          </div>

          {/* Stats */}
          <div className="flex gap-6 mb-4">
            <div className="text-center">
              <div className="text-base font-bold text-zinc-50">{following}</div>
              <div className="text-xs text-zinc-400">Following</div>
            </div>
            <div className="text-center">
              <div className="text-base font-bold text-zinc-50">{followers}</div>
              <div className="text-xs text-zinc-400">Followers</div>
            </div>
            <div className="text-center">
              <div className="text-base font-bold text-zinc-50">{likes}</div>
              <div className="text-xs text-zinc-400">Likes</div>
            </div>
          </div>

          {/* Bio */}
          <p className="mb-4 max-w-xs text-center text-sm whitespace-pre-wrap text-zinc-100">{bio}</p>

          {/* Action buttons (mocked) */}
          <div className="flex gap-2 w-full max-w-xs">
            <button className="flex-1 bg-[#FE2C55] text-white text-sm font-semibold py-2 px-4 rounded-md opacity-60 cursor-not-allowed">
              Follow
            </button>
            <button className="flex-1 rounded-md border border-zinc-700 px-4 py-2 text-sm font-semibold text-zinc-100 opacity-60 cursor-not-allowed">
              Message
            </button>
          </div>
        </div>
    </PreviewCardShell>
  );
};
